import React, { createContext, useContext, useState } from "react";

interface DraggableContextType {
  tabOrders: Record<string, string[]>;
  setTabOrder: (key: string, order: string[]) => void;
}

const DraggableContext = createContext<DraggableContextType | undefined>(undefined);

export const DraggableProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // key: page/component, value: array of tab keys in order
  const [tabOrders, setTabOrders] = useState<Record<string, string[]>>({});

  const setTabOrder = (key: string, order: string[]) => {
    setTabOrders(prev => ({ ...prev, [key]: order }));
  };

  return (
    <DraggableContext.Provider value={{ tabOrders, setTabOrder }}>
      {children}
    </DraggableContext.Provider>
  );
};

export const useDraggable = () => {
  const ctx = useContext(DraggableContext);
  if (!ctx) throw new Error("useDraggable must be used within DraggableProvider");
  return ctx;
};
